import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: 'AIzaSyCfrWx051kPr_A42W97rXUI7vJOBWDFvI8',
  authDomain: 'poker1337-e76c8.firebaseapp.com',
  projectId: 'poker1337-e76c8',
  storageBucket: 'poker1337-e76c8.firebasestorage.app',
  messagingSenderId: '490686989250',
  appId: '1:490686989250:web:bf54460d0b51d1e2990c5b',
  measurementId: 'G-5Y14XNFYPD',
}

export const firebaseApp = initializeApp(firebaseConfig)

export const analytics =
  import.meta.env.MODE === 'development' ? null : getAnalytics(firebaseApp)
